import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "contact-us-page" }
const _hoisted_2 = { class: "container-custom container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("> ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Contattaci ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_ContactUsForm = _resolveComponent("ContactUsForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Header, null, {
        title: _withCtx(() => [
          _hoisted_4
        ]),
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_ContactUsForm, {
        modelValue: _ctx.form,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form) = $event)),
        onSubmit: _ctx.onSubmit
      }, null, 8, ["modelValue", "onSubmit"])
    ])
  ]))
}